import React, { useState, useContext, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { UserContext } from "../UserContext";
import { serviceLogin } from "../services/axois.service.curd";
import { getResource } from "../services/axois.service.curd";

export default function LoginForm() {
  const [clientname, setClientname] = useState("");
  const [unitCode, setUnitCode] = useState("");
  const [userName, setOpcode] = useState("");
  const [password, setOppass] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [successMessage, setSuccessMessage] = useState("");
  const [signingIn, setSigningIn] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const navigate = useNavigate();
  const { login } = useContext(UserContext);
  const [clients, setClients] = useState([]);

  useEffect(() => {
    const fetchClients = async () => {
      try {
        const response = await getResource("AddNewClient", "ClientList");
        setClients(response || []);
      } catch (error) {
        console.error("Failed to fetch clients:", error);
        setErrorMessage("Failed to load clients. Please try again later.");
      }
    };
    fetchClients();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (unitCode === "") {
      setErrorMessage("Please select a client");
      document.getElementById("clientname").focus();
      return;
    }

    const loginDto = {
      OpName: userName,
      opNpass: password,
      unitCode,
    };
    setSigningIn(true);
    try {
      serviceLogin("Authentication", "login", loginDto)
        .then((response) => {
          if (typeof response === "object" && response.length > 0) {
            setSuccessMessage("Login successful");
            login(
              userName,
              unitCode,
              response[0].opCd,
              response[0].ip,
              clientname
            );
            navigate("/");
            setErrorMessage("");
          } else {
            setErrorMessage(response);
            setSuccessMessage("");
          }
        })
        .catch((error) => {
          console.error("Login failed", error);
          setErrorMessage("Invalid User Name or Password");
          setSuccessMessage("");
        })
        .finally(() => setSigningIn(false));
    } catch (error) {
      setSigningIn(false);
    }
  };

  return (
    <div className="auth-page">
      <div className="auth-card">
        <div className="auth-brand">
          <img src="assets/img/sislLogo.png" alt="SISL" />
          <span>NSWS API INTEGRATION</span>
        </div>
        <h1 className="auth-title">Login to Your Account</h1>
        <p className="auth-subtitle">Enter your username &amp; password to login</p>

        <form className="row g-3" noValidate onSubmit={handleSubmit}>
          <div className="col-12">
            <label htmlFor="clientname" className="form-label">
              Client
            </label>
            <select
              className="form-select"
              id="clientname"
              name="clientname"
              value={unitCode}
              onChange={(e) => {
                setClientname(e.target.options[e.target.selectedIndex].text);
                setUnitCode(e.target.value);
              }}
              required
            >
              <option value="">Select Client</option>
              {clients.map((client) => (
                <option key={client.unitCode} value={client.unitCode}>
                  {client.clientName}
                </option>
              ))}
            </select>
          </div>

          <div className="col-12">
            <label htmlFor="opcode" className="form-label">
              Username
            </label>
            <div className="input-group">
              <span className="input-group-text bg-white">
                <i className="bi bi-person" aria-hidden="true" />
              </span>
              <input
                type="text"
                name="username"
                className="form-control"
                id="opcode"
                value={userName}
                onChange={(e) => setOpcode(e.target.value)}
                autoComplete="username"
                required
              />
            </div>
          </div>

          <div className="col-12">
            <label htmlFor="oppass" className="form-label">
              Password
            </label>
            <div className="input-group">
              <span className="input-group-text bg-white">
                <i className="bi bi-lock" aria-hidden="true" />
              </span>
              <input
                type={showPassword ? "text" : "password"}
                name="password"
                className="form-control"
                id="oppass"
                value={password}
                onChange={(e) => setOppass(e.target.value)}
                autoComplete="current-password"
                required
              />
              <button
                type="button"
                className="btn btn-reveal"
                onClick={() => setShowPassword((prev) => !prev)}
                aria-label={showPassword ? "Hide password" : "Show password"}
                title={showPassword ? "Hide" : "Show"}
              >
                <i className={`bi ${showPassword ? "bi-eye-slash" : "bi-eye"}`} />
              </button>
            </div>
          </div>

          <div className="col-12">
            <button
              className="btn btn-primary w-100 py-2 fw-semibold"
              type="submit"
              disabled={signingIn}
            >
              {signingIn && (
                <span className="spinner-border spinner-border-sm me-2" aria-hidden="true" />
              )}
              Login
            </button>
          </div>
          {(errorMessage || successMessage) && (
            <div className="col-12">
              {errorMessage && (
                <div className="alert alert-danger mb-0 py-2">{errorMessage}</div>
              )}
              {successMessage && (
                <div className="alert alert-success mb-0 py-2">{successMessage}</div>
              )}
            </div>
          )}
        </form>
        <div className="auth-footer">NSWS API Integration by SISL</div>
      </div>
    </div>
  );
}
